"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customerOrderPreApi = require("@/api/customerOrderPreApi");
var _systemSetting = require("@/api/systemSetting");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'EditCardDialog',
  props: {
    programOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      submitLoading: false,
      formData: this.getDefaultFormData(),
      rules: {
        cardFaceName: [{
          required: true,
          message: '请输入卡面名称',
          trigger: 'blur'
        }, {
          max: 50,
          message: '卡面名称不能超过50个字',
          trigger: 'blur'
        }],
        availableProgram: [{
          required: true,
          message: '请选择可用小程序',
          trigger: 'change'
        }],
        frontStyleUrl: [{
          required: true,
          message: '请上传卡面正面样式',
          trigger: 'change'
        }],
        backStyleUrl: [{
          required: true,
          message: '请上传卡面背面样式',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    open: function open(row) {
      this.formData = {
        id: row.id,
        batchNo: row.batchNo,
        cardFaceName: row.cardFaceName,
        availableProgram: this.getProgramId(row),
        frontStyleUrl: row.frontStyleUrl || '',
        backStyleUrl: row.backStyleUrl || '',
        remark: row.remark || ''
      };
      this.visible = true;
    },
    getDefaultFormData: function getDefaultFormData() {
      return {
        id: '',
        batchNo: '',
        cardFaceName: '',
        availableProgram: '',
        frontStyleUrl: '',
        backStyleUrl: '',
        remark: ''
      };
    },
    handleClose: function handleClose() {
      var _this = this;
      this.formData = this.getDefaultFormData();
      this.$nextTick(function () {
        if (_this.$refs.editCardForm) {
          _this.$refs.editCardForm.clearValidate();
        }
        _this.clearFileInput('front');
        _this.clearFileInput('back');
      });
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs.editCardForm.validate(function (valid) {
        if (!valid) return;
        if (_this2.submitLoading) return;
        var selectedProgram = _this2.programOptions.find(function (item) {
          return String(item.id) === String(_this2.formData.availableProgram);
        });
        var params = _objectSpread(_objectSpread({}, _this2.formData), {}, {
          availableProgram: String(_this2.formData.availableProgram),
          availableProgramNames: selectedProgram ? selectedProgram.appName : ''
        });
        _this2.submitLoading = true;
        (0, _customerOrderPreApi.customerOrderPreUpdateApi)(params).then(function () {
          _this2.$message.success('修改成功');
          _this2.$emit('submit', params);
          _this2.visible = false;
        }).catch(function () {}).finally(function () {
          _this2.submitLoading = false;
        });
      });
    },
    getProgramId: function getProgramId(row) {
      if (Array.isArray(row.availableProgramIds)) {
        return row.availableProgramIds.length ? String(row.availableProgramIds[0]) : '';
      }
      if (typeof row.availableProgram === 'number') return String(row.availableProgram);
      if (typeof row.availableProgram === 'string') {
        var ids = row.availableProgram.split(',').map(function (item) {
          return item.trim();
        }).filter(Boolean);
        return ids.length ? ids[0] : '';
      }
      return '';
    },
    triggerImageSelect: function triggerImageSelect(type) {
      var refName = type === 'front' ? 'frontImageInput' : 'backImageInput';
      if (this.$refs[refName]) {
        this.$refs[refName].click();
      }
    },
    handleImageChange: function handleImageChange(event, type) {
      var _this3 = this;
      var file = event.target.files && event.target.files[0];
      if (!file) return;
      if (!file.type || file.type.indexOf('image/') !== 0) {
        this.$message.error('只能上传图片文件');
        this.clearFileInput(type);
        return;
      }
      var formData = new FormData();
      formData.append('multipart', file);
      var field = type === 'front' ? 'frontStyleUrl' : 'backStyleUrl';
      var loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading'
      });
      (0, _systemSetting.fileImageApi)(formData, {
        model: this.$route.path.split('/')[1],
        pid: 10
      }).then(function (res) {
        _this3.formData[field] = res.url;
        _this3.$message.success('上传成功');
        _this3.$nextTick(function () {
          _this3.$refs.editCardForm.validateField(field);
        });
      }).catch(function () {}).finally(function () {
        loading.close();
        _this3.clearFileInput(type);
      });
    },
    removeImage: function removeImage(type) {
      var _this4 = this;
      var field = type === 'front' ? 'frontStyleUrl' : 'backStyleUrl';
      this.formData[field] = '';
      this.clearFileInput(type);
      this.$nextTick(function () {
        _this4.$refs.editCardForm.validateField(field);
      });
    },
    clearFileInput: function clearFileInput(type) {
      var refName = type === 'front' ? 'frontImageInput' : 'backImageInput';
      if (this.$refs[refName]) {
        this.$refs[refName].value = '';
      }
    }
  }
};